import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MacroActionValueDto,
  MacroAddDxDto,
  MacroDefinitionDto,
  MacroDeleteResultDto,
  MacroExecutionDto,
  MacroExecutionResultDto,
  MacroGetDto
} from 'webcommon/shared';
import { PrmHttpClientService } from 'webcommon/webapi';
@Injectable({
  providedIn: 'root',
})
export class MacroRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) { }

  addDx(patientId: string, visitId: string, addDxs: MacroAddDxDto[]): Observable<MacroAddDxDto[]> {
    const endpointUrl = `patients/${patientId}/fnd/macro/addDx/${visitId}`;
    return this.httpClientService.sendPostRequest(endpointUrl, addDxs);
  }

  executeMacroBackend(patientId: string, visitId: string, param: MacroExecutionDto): Observable<MacroExecutionResultDto> {
    const endpointUrl = `patients/${patientId}/fnd/macro/executeMacroBackend/${visitId}`;

    return this.httpClientService.sendPostRequest(endpointUrl, param);
  }

  getMacroList(patientId: string, macroGetDto: MacroGetDto): Observable<MacroDefinitionDto[]> {
    const endpointUrl = `patients/${patientId}/fnd/macro/list`;
    return this.httpClientService.sendPostRequest(endpointUrl, macroGetDto);
  }

  getMacroValue(
    patientId: string,
    visitId: string | null,
    macroName: string | null,
    macroId: string | null,
    macroSelectionIds: string[],
    editorName: string,
  ): Observable<MacroActionValueDto> {
    const endpointUrl = `patients/${patientId}/fnd/macro/value/${visitId ?? ''}`;
    let params = new HttpParams();
    if (macroName) {
      params = params.set('macroName', macroName);
    }

    if (macroId) {
      params = params.set('macroResultId', macroId);
    }

    if (macroSelectionIds) {
      params = params.set('macroSelectionIds', macroSelectionIds.join(','));
    }

    if (editorName) {
      params = params.set('editorName', editorName);
    }

    return this.httpClientService.sendGetRequest(endpointUrl, params);
  }

  saveMacro(patientId: string, macroDefinition: MacroDefinitionDto): Observable<MacroDefinitionDto> {
    const endpointUrl = `patients/${patientId}/fnd/macro/saveMacro`;
    return this.httpClientService.sendPostRequest(endpointUrl, macroDefinition);
  }

  deleteMacro(patientId: string, macroId: string): Observable<MacroDeleteResultDto> {
    const endpointUrl = `patients/${patientId}/fnd/macro/delete-macro/${macroId}`;
    return this.httpClientService.sendDeleteRequest(endpointUrl);
  }
}
